import React from 'react'

import { DiscoCallout, Link } from 'components/ds'
import ContactUsLink from 'components/ui/contact-us-link'

/**
 * Error state component for when billing provider payment scripts fail to load
 * Displays user-friendly error message with retry option and contact support link
 * @param onRetry - Function to retry loading the billing provider
 */
const BillingProviderLoadError = ({
  onRetry,
}: {
  onRetry: (...args: Array<any>) => any
}): React.ReactNode => {
  return (
    <DiscoCallout type="warning-important">
      Sorry! There was an issue loading our payment provider. You can{' '}
      <Link asChild className="text-link">
        <button type="button" onClick={onRetry}>
          retry
        </button>
      </Link>
      , or if you continue to have issues,{' '}
      <ContactUsLink
        className="text-link"
        intercomMsg="I’m having issues loading the subscription form"
      >
        contact us.
      </ContactUsLink>
    </DiscoCallout>
  )
}

export default BillingProviderLoadError
